import { useEffect } from 'react';
import { FeatureFlags } from '@packages/shared/core/feature-flags/services';

const linkUsageEvents = ['click', 'auxclick', 'contextmenu'] as const;

export const useSplitIdInOutgoingLinks = (featureFlags: FeatureFlags, domainRoot: string) => {
  useEffect(() => {
    const rootHostname = domainRoot.replace(/^\./, '');

    if (!rootHostname) return;

    const addSplitIdToLink = (event: MouseEvent) => {
      const link = event.target instanceof Element ? event.target.closest('a[href]') : null;

      if (!(link instanceof HTMLAnchorElement)) return;

      const isOurDomain =
        link.hostname === rootHostname || link.hostname.endsWith(`.${rootHostname}`);
      const splitId = featureFlags.getSplitId();

      if (!isOurDomain || !splitId) return;

      const url = new URL(link.href);
      url.searchParams.set('split_id', splitId);
      link.href = url.href;
    };

    linkUsageEvents.forEach((eventName) => {
      document.addEventListener(eventName, addSplitIdToLink, true);
    });

    return () => {
      linkUsageEvents.forEach((eventName) => {
        document.removeEventListener(eventName, addSplitIdToLink, true);
      });
    };
  }, [featureFlags, domainRoot]);
};
